import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Grid, IconButton, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { useFilter } from '../../hooks/useFilter';
import { usePages } from '../../hooks/usePages';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';
import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';

import { Layout } from '../../components/Layout';
import { SearchTextField } from '../../components/SearchTextField';

import { TipoNotificacionProps } from '../../interfaces/catalogos/TipoNotificacionInterface';

import { ActualizarTipoNotificacion, AgregarTipoNotificacion, TipoNotificaciones } from '../../connections/catalogos/TipoNotificacionConnection';

export const TipoNotificacionPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [TipoNotificacionArray, setTipoNotificacionArray] = useState<TipoNotificacionProps[]>( [] );

    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idTipoNotificacion, setIdTipoNotificacion] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( TipoNotificacionArray, ( item, filtro ) => item.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const TipoNotificacionSelected = TipoNotificacionArray.find( ( elem ) => elem.idTipoNotificacion === id );

        if ( TipoNotificacionSelected ) {

            await ActualizarTipoNotificacion({ ...TipoNotificacionSelected, activo: checked }).then( resp => {

                if ( resp.idTipoNotificacion ) {

                    var newArray = TipoNotificacionArray.map( ( elem ) => {

                    if ( elem.idTipoNotificacion === id ) {
                        elem.activo = checked;
                    }

                        return elem;
                    });

                    setTipoNotificacionArray( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));
                }

            });
        }

    }

    const handleGuardar = async () => {

        if ( idTipoNotificacion !== 0 ) {

            const TipoNotificacionSelected = TipoNotificacionArray.find( ( elem ) => elem.idTipoNotificacion === idTipoNotificacion );

            if ( TipoNotificacionSelected ) {

                setLoading( true );

                await ActualizarTipoNotificacion({ ...TipoNotificacionSelected, descripcion, }).then( resp => {

                    if ( resp.idTipoNotificacion ) {

                        setTimeout(() => {

                            var newArray = TipoNotificacionArray.map( ( elem ) => {

                                if ( elem.idTipoNotificacion === idTipoNotificacion ) {
                                    elem.descripcion = descripcion;
                                }

                                return elem;
                            });

                            setTipoNotificacionArray( newArray );
                            setOpenDialog( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }

        }
        else {

            const TipoNotificacionAdd: TipoNotificacionProps = {
                idTipoNotificacion: 0,
                descripcion,
                activo: true,
            }

            setLoading( true );

            await AgregarTipoNotificacion( TipoNotificacionAdd ).then( resp => {

                if ( resp.idTipoNotificacion ) {

                    setTimeout(() => {

                        setTipoNotificacionArray([ ...TipoNotificacionArray, resp ]);
                        setOpenDialog( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó el tipo de notificación correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function Obtener() {

            setLoadingData( true );
            setTipoNotificacionArray( [] );

            await TipoNotificaciones().then( resp => {

                setTimeout(() => {

                    setTipoNotificacionArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        Obtener();

    }, [])

    return (

        <Layout breadcrumbs={  [  { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de notificación' } ]} backgroundPaper={ false }>

            <Grid container spacing={ 3 } >

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' }>

                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdTipoNotificacion( 0 );
                            setDescripcion( '' );

                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'75%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                :
                                    dataFiltrada
                            )
                            .map( ( { idTipoNotificacion, descripcion, activo } ) => (

                                <TableRow key={ idTipoNotificacion } >

                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                        { idTipoNotificacion }
                                    </TableCell>

                                    <TableCell>
                                        { descripcion }
                                    </TableCell>

                                    <TableCell sx={{ textAlign: 'end' }}>

                                        <Switch
                                            checked={ activo }
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idTipoNotificacion ) }
                                        />

                                        <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => {

                                                    setIdTipoNotificacion( idTipoNotificacion );
                                                    setDescripcion( descripcion );

                                                    setOpenDialog( true );
                                                }}
                                            >
                                            <EditIcon />
                                        </IconButton>

                                    </TableCell>

                                </TableRow>

                            ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={ 7 } align='center'>

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={ 1 } sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: { dataFiltrada.length }
                                        </Typography>
                                    </TableCell>

                                    <TablePagination
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        colSpan={ 8 }
                                        count={ dataFiltrada.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialog } maxWidth='sm' fullWidth={ true }>

                <DialogContent sx={ DialogContentStyle }>

                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Descripción' }
                        variant='outlined'
                        multiline
                        rows={ 4 }
                        fullWidth
                        value={ descripcion }
                        onChange={ (e) => setDescripcion( e.target.value ) }
                        slotProps={{
                            input: {
                                autoComplete: 'off'
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }}
                    />

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => { setOpenDialog( false ); } }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}